import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadThoughtsMetadata } from '../unspokenThoughts/LoadMetadata';
import { ArtData } from '../../utils/ArtData';
import { Routes } from '../../utils/Routes';
import MusicCard from '../../components/unspokenMusic/MusicCard';
import musicMetadata from '../../assets/music/metadata.json';
import { ArtBookData } from '../../utils/ArtBookData';

export default function FeaturedArt() {
  const [featuredArt, setFeaturedArt] = useState<any[]>([]);

  useEffect(() => {
    const thoughtsData = loadThoughtsMetadata();
    const featuredThoughts = thoughtsData.filter(
      (art) => art?.featured === true,
    );
    const featuredUnspokenArt = ArtData.filter(
      (art) => art.metadata?.featured === true,
    );
    const featuredArtBooks = ArtBookData.filter(
      (book) => book.featured === true,
    );
    const combinedFeatured = [
      ...featuredThoughts,
      ...featuredUnspokenArt,
      ...featuredArtBooks,
    ].sort(() => 0.5 - Math.random());
    setFeaturedArt(combinedFeatured.slice(0, 3));
  }, []);

  const featuredMusicMeta = musicMetadata.find(
    (music) => music.featured === true,
  );

  return (
    <div className="w-full flex flex-col gap-5">
      {/* Section Header */}
      <div className="flex items-center gap-3">
        <p className="text-xs uppercase tracking-widest text-custom-stone/80 shrink-0">
          Featured
        </p>
        <div className="flex-1 h-px bg-white/10" />
      </div>

      {/* Art Grid */}
      {featuredArt.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
          {featuredArt.map((art) => {
            const isArtBook = !!art.coverImage;
            const isUnspokenArt = !isArtBook && !!art.metadata;
            const linkTo = isArtBook
              ? art.route
              : isUnspokenArt
                ? `${Routes.Art}/${art.metadata.id}`
                : `${Routes.Thoughts}/${art.id}`;
            const imageSrc = isArtBook
              ? art.coverImage
              : isUnspokenArt
                ? art.image
                : art.thumbnail;
            const title = isArtBook
              ? art.title
              : isUnspokenArt
                ? art.metadata.title
                : art.title;
            const label = isArtBook ? 'Art Book' : isUnspokenArt ? 'Art' : 'Thought';

            return (
              <Link
                key={art.id || art.metadata?.id}
                to={linkTo}
                className="group block overflow-hidden rounded-lg bg-black/30 border border-white/10 hover:border-custom-stone/40 transition-colors duration-300"
              >
                <div className="w-full h-32 overflow-hidden">
                  <img
                    src={imageSrc}
                    alt={title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="px-3 py-2.5">
                  <p className="text-xs uppercase tracking-widest text-custom-stone/60 mb-0.5">
                    {label}
                  </p>
                  <h3 className="text-sm font-medium text-white/80 truncate group-hover:text-white transition-colors duration-200">
                    {title || 'Untitled'}
                  </h3>
                </div>
              </Link>
            );
          })}
        </div>
      )}

      {/* Featured Music */}
      {featuredMusicMeta && (
        <MusicCard
          musicFileName={featuredMusicMeta.filename}
          title={featuredMusicMeta.title}
          artist={featuredMusicMeta.artist}
        />
      )}
    </div>
  );
}
